import { useDndContext } from "@dnd-kit/core";
import { EuiIcon } from "@inscopix/ideas-eui";
import { TABLE_ICONS } from "types/Icons";

export interface TableIconProps {
  tableType: "analysis" | "data" | "workflow";
}
export const TableIcon = ({ tableType }: TableIconProps) => {
  const { active } = useDndContext();
  return (
    <EuiIcon
      type={TABLE_ICONS[tableType]}
      size="m"
      style={{ verticalAlign: "text-top" }}
      className={`table-icon ${active !== null ? "table-dragging" : ""}`}
    />
  );
};
